import ResourcePage from "@/components/common/ResourcePage";
import { Badge } from "@/components/common/DataTable";

export default function WhiteLabelPage() {
  return (
    <ResourcePage
      title="White Label" subtitle="Tenant & partner branding configurations"
      base="/v1/white-label" perm="WHITELABEL"
      columns={[
        { key: "scope", header: "Scope", render: (r) => <Badge color="blue">{r.scope}</Badge> },
        { key: "scopeRef", header: "Scope Ref", render: (r) => <span className="font-mono text-xs">{(r.scopeRef || "").slice(0, 12)}</span> },
        { key: "customDomain", header: "Custom Domain", render: (r) => r.customDomain || "—" },
        { key: "status", header: "Status" },
      ]}
      fields={[
        { name: "scope", label: "Scope", type: "select", options: ["Tenant", "Partner"] },
        { name: "scopeRef", label: "Scope Ref (tenant/partner id)" },
        { name: "logoUrl", label: "Logo URL" },
        { name: "customDomain", label: "Custom Domain", placeholder: "app.acme.com" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}
